'use client';
import { useGetTheme } from '@/theme';
import createEmotionCache from '@/utils/createEmotionCache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, ThemeProvider } from '@mui/material';

export function Theme({ children, lang }: { children: React.ReactNode; lang: 'en' | 'ar' }) {
  const theme = useGetTheme();
  const [cacheLtr, cacheRtl] = createEmotionCache();

  return (
    <CacheProvider value={lang === 'en' ? cacheLtr : cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
}
